export default __webpack_public_path__ + "static/media/fixture2_header.50335621.png";